import dynamic from 'next/dynamic';
import { StorePage as OldStorePage } from 'components/pages/store/StorePage';
import { Inventory } from 'models/sku.model';
import {
  WallOfCardsQuery,
  SkuPresentationListQuery,
  StorePageQuery,
  PrezzeePlusStoreBannerQuery,
} from 'api/graphql/generated-bff';
import ZagExplanationModal from 'components/pages/store/zag/ZagExplanationModal';
import { useDisclosure } from '@chakra-ui/hooks';
import { WebConfig } from 'models/webConfig.model';
import { useRouter } from 'next/router';
import { useNavVisibilty } from 'contexts/NavVisibilityContext';
import { c } from 'msw/lib/glossary-de6278a9';

// @ts-ignore
const RemoteWoc = dynamic(() => import('consumer_woc/App'), { loading: () => <span></span>, ssr: false });
const RemoteHeroBanner = dynamic(() => import('../components/heroBanner/RemoteHeroBanner'), {
  loading: () => <span></span>,
  ssr: false,
});

type StorePageProps = {
  storePageContentItems: StorePageQuery['cms_page']['content']['contentBlocks']['items'];
  smartCardContent: PrezzeePlusStoreBannerQuery;
  inventory: WallOfCardsQuery['inventory'] | Inventory;
  store: WallOfCardsQuery['cms_store'];
  presentationList: SkuPresentationListQuery['cms_skuPresentation_All']['items'];
  config: WebConfig;
};

const StorePage = ({
  inventory,
  store,
  presentationList,
  storePageContentItems,
  smartCardContent,
  config,
  ...rest
}: StorePageProps) => {
  const zagModal = useDisclosure();
  const router = useRouter();
  const navIsVisible = useNavVisibilty();

  if (!config.featureLayerBuyingWeb) {
    // @ts-ignore
    return <OldStorePage inventory={inventory} {...rest} />;
  }

  const onClickBannerCta = btn => {
    //TODO: Remove after christmas 2024
    if (btn?.ctaText && btn?.ctaUrl) {
      window.location.assign(btn.ctaUrl);
    } else {
      zagModal.onOpen();
    }
  };

  const onClickSmartCardContentLink = (link?: string) => {
    switch (link) {
      case '#modal_prezzee-plus-explanation': {
        zagModal.onOpen();
        break;
      }
      default: {
        router.push(link);
      }
    }
  };

  return (
    <>
      {storePageContentItems.map((item, index) => {
        // @ts-ignore
        switch (item.__typename) {
          case 'Cms_HeroBanner':
            return (
              <RemoteHeroBanner
                /* @ts-ignore */
                key={item.__typename + index.toString()}
                data={item}
                onClickBannerCta={btn => onClickBannerCta(btn)}
                marginTop="40px"
                paddingX="16px"
              />
            );
        }
      })}
      <RemoteWoc
        // @ts-ignore
        inventory={inventory}
        store={store}
        presentationList={presentationList}
        smartCardContent={smartCardContent}
        onClickSmartCardContentLink={onClickSmartCardContentLink}
        navIsVisible={navIsVisible}
      />
      {zagModal.isOpen && <ZagExplanationModal onClose={zagModal.onClose} />}
    </>
  );
};

export default StorePage;
